
// import { useParams, Link } from "react-router-dom";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useCart } from "../context/CartContext";
import toast from "react-hot-toast";
import RichText from "../components/RichText";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import {
  ShoppingBag,
  ShoppingCart,
  Star,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

import "swiper/css";
import "swiper/css/navigation";

import { AuthAPI } from "../api/AuthAPI";
import Swal from "sweetalert2"

export default function ProductPage() {
  const { id } = useParams();
const [showReviewPopup, setShowReviewPopup] = useState(false);
  const { addToCart, openCart } = useCart();
const navigate = useNavigate();
  const [product, setProduct] = useState(null);

  const [activeImage, setActiveImage] = useState(null);

  const [zoomStyle, setZoomStyle] = useState({
    transformOrigin: "center",
    transform: "scale(1)",
  });
const [reviewPage, setReviewPage] =
  useState(1);

const [reviewPagination,
  setReviewPagination] =
  useState(null);
  const [isZoomed, setIsZoomed] = useState(false);

  const [relatedProducts, setRelatedProducts] = useState([]);

  const [reviews, setReviews] = useState([]);

  const [rating, setRating] = useState(0);

  const relatedSwiperRef = useRef(null);

  /* ================= LOAD REVIEWS ================= */

  // const loadReviews = async (productId) => {
  //   try {
  //     const res = await AuthAPI.getReviews(productId);

  //     setReviews(res?.data?.data || []);
  //   } catch (err) {
  //     console.error("Failed to load reviews", err);
  //   }
  // };
const loadReviews = async (
  productId,
  page = 1
) => {

  try {

    const res =
      await AuthAPI.getReviews(
        productId,
        page,
        5
      );

    setReviews(
      res?.data?.data || []
    );

    setReviewPagination(
      res?.data?.settings
    );

  } catch (err) {

    console.error(
      "Failed to load reviews",
      err
    );

  }

};
  /* ================= ACTIVE IMAGE ================= */

  useEffect(() => {
    if (product?.images?.length) {
      setActiveImage(product.images[0]);
    }
  }, [id]);

  /* ================= LOAD PRODUCT ================= */

  useEffect(() => {
    async function loadProduct() {
      try {
        const res = await AuthAPI.getsingleproduct(id);

        const p = res?.data?.data;

        if (!p) return;

        const images = p.images?.length
          ? p.images.map((i) => i.image)
          : p.image
            ? [p.image]
            : [];

        setProduct({
          ...p,
          images,
          descriptionShort: p.description,
          descriptionLong: p.description,
          categoryName: p.category?.name,
          categoryId: p.category?.id,
        });

        setActiveImage(images[0] || "");

        if (p.category?.id) {
          loadRelatedProducts(p.category.id, p.id);
        }
loadReviews(p.id, reviewPage);
      } catch (err) {
        console.error("Failed to load product", err);
      }
    }

    async function loadRelatedProducts(categoryId, currentId) {
      try {
        const res = await AuthAPI.getproducts({
          category_id: categoryId,
          limit: 10,
        });

        setRelatedProducts(
          (res?.data?.data || [])
            .filter((x) => x.id !== currentId)
            .map((p) => ({
              ...p,
              images: p.images?.length
                ? p.images.map((i) => i.image)
                : p.image
                  ? [p.image]
                  : [],
            })),
        );
      } catch (err) {
        console.error("Failed to load related products", err);
      }
    }

    loadProduct();
  }, [id,reviewPage]);

  if (!product)
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading...
      </div>
    );

  /* ================= SUBMIT REVIEW ================= */
async function handleSubmitReview(e) {

  e.preventDefault();

  const form = e.target;

  const payload = {
    product_id: product.id,
    review: form.review.value,
    rating: rating,
  };

  try {

    const res =
      await AuthAPI.createReview(
        payload
      );

    form.reset();

    setRating(0);

    setShowReviewPopup(false);

    loadReviews(product.id);

    Swal.fire({
      icon: "success",
      title: "Success",
      text:
        res?.data?.message ||
        "Review submitted successfully",
      confirmButtonColor:
        "#16a34a",
    });

  } catch (err) {

    console.error(
      "Review submit failed",
      err
    );

    Swal.fire({
      icon: "error",
      title: "Failed",
      text:
        err?.response?.data
          ?.message ||
        "Failed to submit review",
      confirmButtonColor:
        "#dc2626",
    });

  }

}
  return (
    <main
      className="
        min-h-screen
        bg-gradient-to-b
        from-[#fff7fb]
        via-white
        to-[#f5f7ff]
        px-4
        py-8
        md:py-12
        mt-10 
        md:mt-0
      "
    >
      <div className="max-w-7xl mx-auto">
        {/* ================= PRODUCT SECTION ================= */}

        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-2
            gap-10

            bg-white/90
            backdrop-blur-xl

            rounded-[32px]

            border
            border-pink-100

            shadow-[0_10px_40px_rgba(236,72,153,0.08)]

            p-5
            md:p-8
          "
        >
          {/* ================= IMAGES ================= */}

          <div className="flex flex-col gap-5">
            {/* MAIN IMAGE */}

            {activeImage && (
              <div
                className="
                  w-full
                  flex
                  justify-center
                  items-center

                  rounded-[28px]

                  bg-gradient-to-b
                  from-pink-50
                  to-white

                  p-4
                  md:p-6
                "
              >
                <div
                  className="
                    relative
                    overflow-hidden
                    rounded-[28px]
                    cursor-zoom-in
                    group
                  "
                  onMouseMove={(e) => {
                    const { left, top, width, height } =
                      e.currentTarget.getBoundingClientRect();

                    const x = ((e.clientX - left) / width) * 100;
                    const y = ((e.clientY - top) / height) * 100;

                    setZoomStyle({
                      transformOrigin: `${x}% ${y}%`,
                      transform: "scale(2.2)",
                    });

                    setIsZoomed(true);
                  }}
                  onMouseLeave={() => {
                    setZoomStyle({
                      transformOrigin: "center",
                      transform: "scale(1)",
                    });

                    setIsZoomed(false);
                  }}
                >
                  <img
                    src={activeImage}
                    alt={product.name}
                    style={zoomStyle}
                    className="
                      w-full
                      max-w-[500px]

                      h-[240px]
                      sm:h-[320px]
                      md:h-[460px]

                      object-cover

                      transition-transform
                      duration-200
                      ease-out

                      will-change-transform
                    "
                    onError={(e) => (e.currentTarget.style.display = "none")}
                  />

                  {/* MAGNIFIER ICON */}

                  <div
                    className="
                      absolute
                      bottom-4
                      right-4

                      w-10
                      h-10

                      rounded-full

                      bg-white/90
                      backdrop-blur-md

                      flex
                      items-center
                      justify-center

                      shadow-lg

                      opacity-0
                      group-hover:opacity-100

                      transition
                    "
                  >
                    🔍
                  </div>
                </div>
              </div>
            )}

            {/* THUMBNAILS */}

            <div className="w-full max-w-md mx-auto relative">
              <Swiper
                modules={[Navigation]}
                navigation
                spaceBetween={12}
                slidesPerView={4}
                breakpoints={{
                  0: {
                    slidesPerView: 4,
                  },

                  640: {
                    slidesPerView: 5,
                  },
                }}
              >
                {product.images.map((img, i) => (
                  <SwiperSlide key={i}>
                    <button
                      onClick={() => setActiveImage(img)}
                      className={`
                        rounded-2xl
                        p-2
                        w-full
                        h-[84px]

                        bg-white

                        border-2

                        transition-all
                        duration-300

                        ${
                          activeImage === img
                            ? "border-pink-500 shadow-md"
                            : "border-pink-100 hover:border-pink-300"
                        }
                      `}
                    >
                      <img
                        src={img}
                        alt=""
                        className="
                          max-h-full
                          object-contain
                          mx-auto
                        "
                      />
                    </button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          {/* ================= PRODUCT INFO ================= */}

          <div className="flex flex-col justify-center">
            {/* CATEGORY */}

            <div
              className="
                inline-flex
                items-center
                gap-2

                rounded-full

                bg-pink-50

                px-4
                py-2

                text-sm
                text-pink-600
                font-medium

                w-fit
                mb-4
              "
            >
              {product.categoryName}
            </div>

            {/* TITLE */}

            <h1
              className="
                font-playfair

                text-[24px]
                md:text-[42px]

                leading-[1.1]

                font-bold

                text-[#1A237E]

                mb-4
              "
            >
              {product.name}
            </h1>

            {/* PRICE */}

            <div className="flex items-center gap-4 mb-5">
              <span
                className="
                  text-[28px]
                  md:text-[38px]

                  font-bold
                  text-pink-500
                  leading-none
                "
              >
                ₹{product.price}
              </span>

              {product.normal_price && (
                <span
                  className="
                    text-lg
                    md:text-xl

                    text-gray-400
                    line-through
                  "
                >
                  ₹{product.normal_price}
                </span>
              )}
            </div>
            {/* PRODUCT AMENITIES */}

            <div className="flex flex-wrap gap-2 mb-6">
              {[
                "Softest top sheet",
                "100% toxic-free",
                "50% wider back",
                "Ultra-thin",
                "With covers",
              ].map((item, index) => (
                <span
                  key={index}
                  className="
        inline-flex
        items-center
        gap-1

        px-3
        py-2

        rounded-md

        bg-teal-50
        text-teal-700

        text-sm
        font-medium

        border
        border-teal-100
      "
                >
                  ✓ {item}
                </span>
              ))}
            </div>
            {/* DESCRIPTION */}

            <p
              className="
                text-[15px]
                md:text-[16px]

                leading-[1.8]
                text-gray-600

                max-w-xl

                mb-7
              "
            >
              <RichText
                html={product.descriptionShort}
                className="max-w-xl mb-7 text-[15px]"
              />
            </p>

            {/* BUTTONS */}

            <div className="flex flex-col sm:flex-row gap-3 mb-8">
              {product.stock <= 0 || product.is_out_of_stock ? (
                <button
                  disabled
                  className="
                    px-8
                    py-3

                    rounded-full

                    bg-gray-300

                    text-white
                    font-semibold

                    cursor-not-allowed
                  "
                >
                  Out of Stock
                </button>
              ) : (
                <>
                  {/* ADD TO CART */}

                  <button
                    onClick={() => {
                      addToCart(product);

                      toast.success("Item added to cart successfully", {
                        duration: 2000,
                      });
                    }}
                    className="
                      flex-1

                      rounded-full

                      bg-gradient-to-r
                      from-pink-500
                      to-pink-400

                      py-3
                      px-6

                      text-white
                      font-semibold
                      text-[15px]

                      shadow-lg

                      transition-all
                      duration-300

                      hover:scale-[1.01]
                      hover:shadow-xl

                      flex
                      items-center
                      justify-center
                      gap-2
                    "
                  >
                    <ShoppingCart size={18} />
                    Add to Cart
                  </button>

                  {/* BUY NOW */}

                  <button
                  onClick={async () => {
  await addToCart(product);

  toast.success("Item added to cart successfully", {
    duration: 2000,
  });

  navigate("/cart");
}}
                    className="
                      flex-1

                      rounded-full

                      border-2
                      border-[#1A237E]

                      bg-white

                      py-3
                      px-6

                      text-[#1A237E]
                      font-semibold
                      text-[15px]

                      transition-all
                      duration-300

                      hover:bg-[#1A237E]
                      hover:text-white

                      flex
                      items-center
                      justify-center
                      gap-2
                    "
                  >
                    <ShoppingBag size={18} />
                    Buy Now
                  </button>
                </>
              )}
            </div>

            {/* REVIEWS */}

            {/* REVIEWS */}
            <div className="mt-8 border-t border-pink-100 pt-6">
              {/* HEADER ROW */}
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-black text-base">REVIEWS</h3>
                {product.is_purchased_and_delivered && (
                  <button
                    onClick={() => setShowReviewPopup(true)}
                    className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-full text-sm font-medium transition"
                  >
                    Write a Review
                  </button>
                )}
              </div>

              {/* REVIEWS LIST */}
              <div className="max-h-[400px] overflow-y-auto space-y-3 pr-1">
                {reviews.length === 0 ? (
                  <p className="text-sm text-gray-400">No reviews yet.</p>
                ) : (
                  reviews.map((r) => (
                    <div
                      key={r.id}
                      className="bg-green-50 border border-green-100 rounded-2xl p-4 flex gap-3"
                    >
                      {/* AVATAR */}
                      <div className="flex-shrink-0">
                        {r.user?.image ? (
                          <img
                            src={r.user.image}
                            alt={r.user?.name}
                            className="w-10 h-10 rounded-full object-cover"
                          />
                        ) : (
                          <div className="w-10 h-10 rounded-full bg-green-200 flex items-center justify-center text-green-700 font-bold text-sm">
                            {r.user?.name?.[0]?.toUpperCase() || "?"}
                          </div>
                        )}
                      </div>

                      {/* CONTENT */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between gap-2">
                          <p className="font-semibold text-gray-800 text-sm">
                            {r.user?.name || "Anonymous"}
                          </p>
                          {/* STARS */}
                          <div className="flex gap-0.5 flex-shrink-0">
                            {[1, 2, 3, 4, 5].map((s) => (
                              <span
                                key={s}
                                className={
                                  s <= r.rating
                                    ? "text-yellow-400 text-sm"
                                    : "text-gray-200 text-sm"
                                }
                              >
                                ★
                              </span>
                            ))}
                          </div>
                        </div>
                        <p className="text-gray-600 text-sm mt-1 leading-relaxed">
                          {r.review}
                        </p>
                        <p className="text-[11px] text-gray-400 mt-1.5">
                          {new Date(r.createdAt).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
              {/* PAGINATION */}

              {reviewPagination?.total_pages > 1 && (
                <div
                  className="
      flex
      items-center
      justify-center
      gap-2
      mt-5
    "
                >
                  <button
                    disabled={!reviewPagination?.prev_page}
                    onClick={() => setReviewPage((p) => p - 1)}
                    className="
        px-4
        py-2

        rounded-full

        border
        border-green-200

        text-sm

        disabled:opacity-40
      "
                  >
                    Prev
                  </button>

                  <span
                    className="
        text-sm
        font-medium
        text-gray-600
      "
                  >
                    Page {reviewPagination.page} of{" "}
                    {reviewPagination.total_pages}
                  </span>

                  <button
                    disabled={!reviewPagination?.next_page}
                    onClick={() => setReviewPage((p) => p + 1)}
                    className="
        px-4
        py-2

        rounded-full

        border
        border-green-200

        text-sm

        disabled:opacity-40
      "
                  >
                    Next
                  </button>
                </div>
              )}
            </div>

            {/* POPUP */}
            {showReviewPopup && (
              <div
                className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
                onClick={() => setShowReviewPopup(false)}
              >
                <div
                  className="bg-white rounded-2xl p-6 w-full max-w-lg shadow-2xl"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* HEADER */}
                  <div className="flex items-start justify-between mb-5 gap-3">
                    <h3 className="font-semibold text-base text-gray-800 leading-snug">
                      Review "{product.name}"
                    </h3>
                    <button
                      onClick={() => setShowReviewPopup(false)}
                      className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 flex-shrink-0 transition"
                    >
                      ✕
                    </button>
                  </div>

                  {/* STAR RATING */}
                  <div className="mb-4">
                    <p className="text-sm font-medium text-gray-700 mb-2">
                      Your Rating *
                    </p>
                    <div className="flex gap-2">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <button
                          key={i}
                          type="button"
                          onClick={() => setRating((r) => (r === i ? 0 : i))}
                          className={`text-3xl transition-transform hover:scale-110 ${
                            i <= rating ? "text-yellow-400" : "text-gray-200"
                          }`}
                        >
                          ★
                        </button>
                      ))}
                    </div>
                  </div>

                  <form onSubmit={handleSubmitReview} className="space-y-4">
                    {/* REVIEW */}
                    <div>
                      <label className="block mb-1.5 text-sm font-medium text-gray-700">
                        Your Review *
                      </label>
                      <textarea
                        name="review"
                        required
                        rows={4}
                        placeholder="Share your experience with this product..."
                        className="w-full border border-gray-200 rounded-xl p-3 text-sm outline-none resize-none focus:border-green-400 focus:ring-2 focus:ring-green-100 transition"
                      />
                    </div>

                    {/* BUTTONS */}
                    <div className="flex gap-3 pt-1">
                      <button
                        type="button"
                        onClick={() => setShowReviewPopup(false)}
                        className="flex-1 py-2.5 rounded-full border border-gray-200 text-gray-600 text-sm font-medium hover:bg-gray-50 transition"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={rating === 0}
                        className="flex-1 py-2.5 rounded-full bg-green-600 hover:bg-green-700 disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-semibold transition"
                      >
                        Submit Review
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ================= RELATED PRODUCTS ================= */}

        <div className="mt-14 relative">
          <h2
            className="
              text-center

              font-playfair

              text-[28px]
              md:text-[38px]

              font-bold

              text-[#1A237E]

              mb-10
            "
          >
            Related
            <span className="text-pink-500"> Products</span>
          </h2>

          {/* ARROWS */}

          <button
            onClick={() => relatedSwiperRef.current?.slidePrev()}
            className="
              absolute
              left-0
              top-1/2
              -translate-y-1/2

              w-11
              h-11

              rounded-full

              bg-white/90
              backdrop-blur-md

              shadow-lg

              border
              border-pink-100

              flex
              items-center
              justify-center

              z-20
            "
          >
            <ChevronLeft size={18} />
          </button>

          <button
            onClick={() => relatedSwiperRef.current?.slideNext()}
            className="
              absolute
              right-0
              top-1/2
              -translate-y-1/2

              w-11
              h-11

              rounded-full

              bg-white/90
              backdrop-blur-md

              shadow-lg

              border
              border-pink-100

              flex
              items-center
              justify-center

              z-20
            "
          >
            <ChevronRight size={18} />
          </button>

          {/* SLIDER */}
          {relatedProducts.length > 0 ? (
            <Swiper
              onSwiper={(swiper) => (relatedSwiperRef.current = swiper)}
              spaceBetween={24}
              breakpoints={{
                0: {
                  slidesPerView: 1.2,
                },

                640: {
                  slidesPerView: 2,
                },

                1024: {
                  slidesPerView: 4,
                },
              }}
            >
              {relatedProducts.map((item) => (
                <SwiperSlide key={item.id}>
                  <Link
                    to={`/products/${item.id}`}
                    className="
                    group

                    rounded-[28px]

                    bg-white/90
                    backdrop-blur-md

                    border
                    border-pink-100

                    p-5

                    flex
                    flex-col
                    items-center
                    gap-4

                    transition-all
                    duration-300

                    hover:-translate-y-1
                    hover:shadow-xl
                  "
                  >
                    <img
                      src={
                        item.images.length > 0
                          ? item.images[0]
                          : "/placeholder.png"
                      }
                      alt={item.name}
                      className="
                      h-44
                      object-contain

                      transition-transform
                      duration-500

                      group-hover:scale-105
                    "
                    />

                    <p
                      className="
                      text-sm
                      font-semibold
                      text-center
                      text-[#1A237E]
                    "
                    >
                      {item.name}
                    </p>

                    <p className="text-pink-500 font-bold">₹{item.price}</p>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div
              className="
      bg-pink-50/40
      border
      border-pink-100
      rounded-[28px]
      py-14
      text-center
    "
            >
              <p
                className="
        text-gray-500
        text-sm
        font-medium
      "
              >
                No related products found.
              </p>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
